<template>
  <div class="date-picker">
    <div class="row no-gutters">
      <div class="col my-auto">
        <input
          id="the-picker"
          :placeholder="placeholder"
          type="date"
          :value="value"
          class="form-control"
          @input="handleUpdate"
        />
        
      </div>
      <div class="col-auto ml-2 my-auto">
        <button class="btn btn-light btn-sm" v-if="showClear" @click="clearDate">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
const flatpickr = require("flatpickr");

export default {
  props: ["value", "minDate", "placeholder", "showClear", "showTime"],
  data() {
    return {
      content: this.value,
      pickr: null
    };
  },
  methods: {
    clearDate() {
      this.pickr.clear();
    },
    handleUpdate() {
      this.$emit("input", this.content);
    }
  },
  mounted() {
    this.pickr = flatpickr("#the-picker", {
      altInput: true,
      altFormat: this.showTime ? "J F Y @ H:i" : "J F Y",
      minDate: this.minDate,
      enableTime: this.showTime,
      onChange: (selectedDates, dateStr, instance) => {
        this.content = dateStr;
        this.$emit("input", moment(dateStr));
      }
    });
  }
};
</script>

<style>
@import "~flatpickr/dist/flatpickr.min.css";
</style>